<template>
  <div class="reset p-5">
    <div class="text-center mb-4">
      <h2 class="font-weight-boldest">Reset Your Password</h2>

      <span class="text-muted">Enter your new password and submit</span>
    </div>

    <div class="login-form">
      <validation-observer ref="observer">
        <div
          class="alert fade text-center font-weight-bolder"
          :class="{
            show: success || error,
            'alert-light-danger': error,
            'alert-light-success': success,
          }"
          v-html="success || error || '&nbsp;'"
          v-if="success || error"
        ></div>

        <b-form-group label="New Password *" label-for="password">
          <validation-provider
            vid="password"
            name="password"
            rules="required|min:3|max:48"
            v-slot="{ errors }"
          >
            <b-form-input
              id="password"
              type="password"
              placeholder="Enter a new password"
              :disabled="loading"
              v-model="form.password"
            ></b-form-input>
            <b-form-text text-variant="danger" v-if="errors[0]">{{
              errors[0]
            }}</b-form-text>
          </validation-provider>
        </b-form-group>

        <b-form-group label="Confirm Password *" label-for="confirm">
          <validation-provider
            name="confirm"
            rules="required|confirmed:password"
            v-slot="{ errors }"
          >
            <b-form-input
              id="confirm"
              type="password"
              placeholder="Confirm the new password"
              :disabled="loading"
              v-model="form.confirm"
            ></b-form-input>
            <b-form-text text-variant="danger" v-if="errors[0]">{{
              errors[0]
            }}</b-form-text>
          </validation-provider>
        </b-form-group>

        <div class="text-center mt-12">
          <button
            class="btn btn-primary rounded-pill mr-8"
            :disabled="loading"
            :class="{ 'spinner spinner-right spinner-sm': loading }"
            @click.stop="submit"
          >
            <span v-if="loading">Resetting...</span>
            <span v-else>Reset</span>
          </button>
          <button
            class="btn btn-secondary rounded-pill"
            :disabled="loading"
            @click="$router.push({ name: 'login' })"
          >
            Cancel
          </button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.full";

import AuthService from "@/services/auth.service";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "ResetPassword",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    async submit() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      if (this.form.password !== this.form.confirm) {
        this.error = "Passwords do not match.";
        return;
      }

      const payload = {
        password: this.form.password,
      };

      this.error = null;
      this.success = null;
      this.loading = true;

      AuthService.resetPassword(this.$route.params.slug, payload)
        .then(() => {
          this.success = `Password changed successfully.`;
          this.reset();
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 5000);
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      if (this.$refs.observer) this.$refs.observer.reset();

      this.form = {
        password: "",
        confirm: "",
      };
    },
  },
  data() {
    return {
      error: null,
      success: null,
      loading: false,

      form: {
        password: "",
        confirm: "",
      },
    };
  },
  mounted() {
    this.error = null;
    this.loading = true;

    AuthService.verifyResetPasswordSlug(this.$route.params.slug)
      .then(() => {
        this.reset();
      })
      .catch(({ message }) => {
        this.error = formatErrorMessage(message);
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
